<template>
  <div class="librarySearch clearfix" :class="type==0?'platform':'library'">
    <div class="center clearfix">
      <div class="selectWrapper l" :class="type==0?'platform_selectWrapper':'library_selectWrapper'">
        <Select class="indexSearch" :class="type==0?'platform_select':''" v-model="select" :list="list"/>
      </div>
      <input type="text" :class="type==0?'platform_input':'library_input'" placeholder="请输入搜索关键字" class="librarySearchInput l" v-model="keywordInput" maxlength="20"/>
      <div class="librarySearchBtn themeBg l" @click="search">搜索</div>
      <div v-if="type!=1 && select.type!==4" class="highSearch" @click="highSearch">高级搜索</div>
    </div>
    <div v-if="type==1 && select.type!==4" class="highSearch website" @click="highSearch">高级搜索</div>
  </div>
</template>

<script>
  import Select from '../components/select.vue'
  import {store} from '../store/store'
export default {
  name: 'searchIndex',
  components: {
    Select
  },
  data() {
    return {
      keywordInput: '',
      type: store.webType, /*0: 平台，1：图书馆*/
      select: {desc: '图书', type: 1},
      list : [{desc: '图书', type: 1}, {desc: '电子书', type: 2}, {desc: '图书馆', type: 3},{desc: '活动', type: 4}, {desc: '资讯', type: 5}],
    }
  },
  created() {
    this.keywordInput = this.$route.query.searchStr || '';
    var selectType = this.$route.query.type? this.$route.query.type - 1 : 0;
    this.select = this.list[selectType]
    if(this.$route.query.libName || store.webType==1){
      this.list = [{desc: '图书', type: 1}, {desc: '电子书', type: 2}, {desc: '活动', type: 4}, {desc: '资讯', type: 5}]
    }
  },
  methods: {
    search() {
      this.$emit('search',this.keywordInput,this.select);
    },
    highSearch(){
      this.$emit('highSearch',this.select);
    },
  }
}
</script>

<style scoped lang="sass">
  /*.webdefault
    .highSearch
      color: $themecolor1
      background-image: url("../assets/images/search_logo.png")*/
  .librarySearch
    width: 100%
    line-height: 40px
  .highSearch
    margin:
      top: 28px
    padding:
      right: 30px
    height: 18px
    line-height: 18px
    text-align: center
    color: $color-333
    cursor: pointer
    background: url("../assets/images/web2_search_logo.png") right center no-repeat
  .platform
    margin: 0 auto
    padding:
      top: 36px
      bottom: 36px
    width: $container-width
    background: #fff
    .librarySearchBtn
      width: 80px
      height: 42px
      line-height: 42px
    .highSearch
      display: inline-block
      vertical-align: middle
      margin:
        left: 20px
        top: 0
    .center
      line-height: 40px
  .library
    margin:
      bottom: 42px
    padding:
      top: 54px
    height: 206px
    background: url("../assets/images/search_bg.jpg") no-repeat
    .librarySearchBtn
      width: 113px
      height: 52px
      line-height: 52px
      letter-spacing: 10px
      text-indent: 10px
    .center
      width: 800px

  .center
    margin: 0 auto
    width: 880px
  .platform_selectWrapper
    height: 42px
    border: 1px solid #e0e0e0
    border:
      right: none
  .library_selectWrapper
    height: 52px
    border: 1px solid #fff
  .selectWrapper
    width: 115px
    padding-right: 1px
    background: #fff url("../assets/images/mainSelectBg.png") right center no-repeat


  .librarySearchInput
    width: 570px
    border: none
    font-size: 16px
    text-indent: 10px
    text-align: left
    color: $color-333
  .library_input
    height: 52px
    border: none
  .platform_input
    height: 42px
    border: 1px solid #e0e0e0
    border:
      left: none
      right: none

  .librarySearchBtn
    text-align: center
    color: #fff
    background: $themecolor1
    cursor: pointer
  .website
    margin:
      left: auto
      right: auto
    width: 94px
</style>
